import { Config } from '../config/Config';
import AsyncStorage from './AsyncStorage';

export const InvokeApi = async (url, params = {}) => {
  try {
    const token = await AsyncStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(params) });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API error:', error);
    return { code: '500', message: 'Network error.' };
  }
};

export const InvokeGetApi = async (url) => {
  try {
    const token = await AsyncStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(url, { method: 'GET', headers });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('GET API error:', error);
    return { code: '500', message: 'Network error.' };
  }
};

export const postImg = async (url, formData) => {
  try {
    const token = await AsyncStorage.getItem('token');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(url, { method: 'POST', headers, body: formData });
    return await response.json();
  } catch (error) {
    return { code: '500', message: error.message };
  }
};

export const apiList = {
  // Auth
  adminLogin: '/adminLogin',

  // Students
  addStudent: '/addStudent',
  getStudents: '/getStudents',
  getStudent: '/getStudent',
  getStudentsByStdSecAcYear: '/getStudentsByStdSecAcYear',
  getStudentsByStandard: '/getStudentsByStandard',
  getStudentsBySection: '/getStudentsBySection',
  getStudentsByStdSec: '/getStudentsByStdSec',
  getStudentsByBirthday: '/getStudentsByBirthday',
  getUpcomingBirthdays: '/getUpcomingBirthdays',
  editStudent: '/editStudent',
  deleteStudent: '/deleteStudent',
  promoteStudent: '/promoteStudent',
  bulkPromoteStudents: '/bulkPromoteStudents',
  addStudentProfileImage: '/addStudentProfileImage',

  // Users
  addUser: '/addUser',
  getUsers: '/getUsers',
  getUser: '/getUser',
  editUser: '/editUser',
  addUserProfileImage: '/addUserProfileImage',

  // Attendance
  addAttendance: '/addAttendance',
  getAttendance: '/getAttendance',
  getAttendanceByStdSec: '/getAttendanceByStdSec',
  getAttendanceByDate: '/getAttendanceByDate',
  getAttendanceByDateStdSec: '/getAttendanceByDateStdSec',
  getAttendanceByMonth: '/getAttendanceByMonth',
  getAttendanceCounts: '/getAttendanceCounts',
  markAbsent: '/markAbsent',
  markAttendance: '/markAttendance',

  // Leave
  addLeave: '/addLeave',
  getLeavesStudents: '/getLeavesStudents',
  getLeavesStudent: '/getLeavesStudent',
  approveLeavesStudent: '/approveLeavesStudent',
  deleteLeavesStudent: '/deleteLeavesStudent',

  // Fees
  addFees: '/addFees',
  getFees: '/getFees',
  getFeesMain: '/getFeesMain',
  getFeesBalance: '/getFeesBalance',
  getFeesTotal: '/getFeesTotal',
  getFeesDate: '/getFeesDate',
  deleteFees: '/deleteFees',
  addFeesRecipt: '/addFeesRecipt',
  addFeesStructure: '/addFeesStructure',
  getFeesStructure: '/getFeesStructure',
  getFeesStructureMain: '/getFeesStructureMain',
  getFeesStructureTotal: '/getFeesStructureTotal',
  deleteFeesStructure: '/deleteFeesStructure',
  
  // Custom Fees
  addStudentCustomFees: '/addStudentCustomFees',
  getStudentCustomFees: '/getStudentCustomFees',
  deleteStudentCustomFees: '/deleteStudentCustomFees',

  // Holidays
  addHoliday: '/addHoliday',
  getHolidays: '/getHolidays',
  getHolidaysMonth: '/getHolidaysMonth',

  // Departments/Sections
  addDeptartmentSection: '/addDeptartmentSection',
  getDeptartmentSection: '/getDeptartmentSection',
  deleteDepartmentSection: '/deleteDepartmentSection',

  // Academic Year
  getCurrentAcademicYear: '/getCurrentAcademicYear',
  getAvailableAcademicYears: '/getAvailableAcademicYears',

  // Assignments
  addAssignment: '/addAssignment',
  getAssignments: '/getAssignments',
  getAssignmentsByStdSecAcYear: '/getAssignmentsByStdSecAcYear',
  deleteAssignment: '/deleteAssignment',
  uploadAssignmentFile: '/uploadAssignmentFile',
  updateAssignmentProgress: '/updateAssignmentProgress',

  // Results
  addResult: '/addResult',
  getResults: '/getResults',
  getResultByStdSecAcYear: '/getResultByStdSecAcYear',
  getResultsMain: '/getResultsMain',
  deleteResult: '/deleteResult',
  deleteResultFull: '/deleteResultFull',

  // Subjects
  addSubject: '/addSubject',
  getSubjects: '/getSubjects',
  deleteSubject: '/deleteSubject',

  // Exams
  addExam: '/addExam',
  getExams: '/getExams',
  deleteExam: '/deleteExam',

  // Timetable
  addTimePeriod: '/addTimePeriod',
  getTimePeriods: '/getTimePeriods',
  deleteTimePeriod: '/deleteTimePeriod',
  getTimetableByStdSec: '/getTimetableByStdSec',
  addTimetable: '/addTimetable',
  deleteTimetable: '/deleteTimetable',

  // Academic Calendar
  addCalendarEvent: '/addCalendarEvent',
  getCalendarEvents: '/getCalendarEvents',
  editCalendarEvent: '/editCalendarEvent',
  deleteCalendarEvent: '/deleteCalendarEvent',

  // Food Menu
  getFoodMenu: '/getFoodMenu',
  addFoodMenu: '/addFoodMenu',
  deleteFoodMenu: '/deleteFoodMenu',

  // Notifications
  sendStudentNotification: '/sendStudentNotification',
  sendBulkNotifications: '/sendBulkNotifications',
  sendBulkNotificationsByStdSec: '/sendBulkNotificationsByStdSec',
  sendBulkNotificationsAll: '/sendBulkNotificationsAll',
  getStudentNotifications: '/getStudentNotifications',
  sendAutoBirthdayNotifications: '/sendAutoBirthdayNotifications',
  sendHolidayReminders: '/sendHolidayReminders',
  sendAssignmentReminders: '/sendAssignmentReminders',
  sendNewStoryNotifications: '/sendNewStoryNotifications',
  sendKidsActivitiesNotifications: '/sendKidsActivitiesNotifications',
  sendFeesReminder: '/sendFeesReminder',
  triggerAllAutoNotifications: '/triggerAllAutoNotifications',

  // Blogs
  addBlogs: '/addBlogs',
  getBlogs: '/getBlogs',
  getBlog: '/getBlog',
  deleteBlog: '/deleteBlog',
  addBlogsImage: '/addBlogsImage',

  // Gallery
  addGallery: '/addGallery',
  getGalleryImages: '/getGalleryImages',
  deleteGallery: '/deleteGallery',
  addGalleryImage: '/addGalleryImage',

  // Programs
  addPrograms: '/addPrograms',
  getPrograms: '/getPrograms',
  deleteProgram: '/deleteProgram',
  addProgramImage: '/addProgramImage',

  // Video Gallery
  addVideoGallery: '/addVideoGallery',
  getVideo: '/getVideo',
  deleteVideo: '/deleteVideo',
  addVideoImage: '/addVideoImage',
  addVideoFile: '/addVideoFile',

  // Sliders
  addSlider: '/addSlider',
  getSliders: '/getSliders',
  deleteSlider: '/deleteSlider',
  addSliderImage: '/addSliderImage',

  // Testimonials
  addTestimonial: '/addTestimonial',
  getTestimonials: '/getTestimonials',
  approveTestimonails: '/approveTestimonails',
  deleteTestimonial: '/deleteTestimonial',
  addTestimonialImage: '/addTestimonialImage',

  // Stories
  addStory: '/addStory',
  getStories: '/getStories',
  updateStory: '/updateStory',
  deleteStory: '/deleteStory',
  addStoryVideo: '/addStoryVideo',
  addStoryThumbnail: '/addStoryThumbnail',

  // Kids Activities
  addKidsActivity: '/addKidsActivity',
  addKidsActivityByStdSec: '/addKidsActivityByStdSec',
  getKidsActivity: '/getKidsActivity',
  getKidsActivities: '/getKidsActivities',
  getKidsActivityByStdSec: '/getKidsActivityByStdSec',
  getKidsActivitiesByStdSec: '/getKidsActivitiesByStdSec',
  updateKidsActivity: '/updateKidsActivity',
  updateKidsActivityByStdSec: '/updateKidsActivityByStdSec',
  addActivityImage: '/addActivityImage',

  // Leads
  addLead: '/addLead',
  getLeads: '/getLeads',
  addVisitor: '/addVisitor',
  getVisitors: '/getVisitors',
  deleteVisitors: '/deleteVisitors',

  // Vehicle Tracking
  getVehicles: '/getVehicles',
  addVehicle: '/addVehicle',
  updateVehicleLocation: '/updateVehicleLocation',
  getVehicleLocation: '/getVehicleLocation',
  getVehicleStudents: '/getVehicleStudents',
  getStudentsForVehicle: '/getStudentsForVehicle',
  assignStudentsToVehicle: '/assignStudentsToVehicle',
  getVehicleSummary: '/getVehicleSummary',
  getAllVehiclesSummary: '/getAllVehiclesSummary',

  // Escort Cards
  getEscortCards: '/getEscortCards',
  addEscortCard: '/addEscortCard',
  updateEscortCard: '/updateEscortCard',
  deleteEscortCard: '/deleteEscortCard',
  generateEscortPass: '/generateEscortPass',
  getAllEscortPasses: '/getAllEscortPasses',
  addEscortPhoto: '/addEscortPhoto',

  // Study Materials (LMS)
  addStudyMaterial: '/addStudyMaterial',
  getStudyMaterials: '/getStudyMaterials',
  deleteStudyMaterial: '/deleteStudyMaterial',
  uploadStudyMaterialFile: '/uploadStudyMaterialFile',
  updateStudyMaterialProgress: '/updateStudyMaterialProgress',

  // Doubts
  getTeacherDoubts: '/getTeacherDoubts',
  getDoubtMessages: '/getDoubtMessages',
  addDoubtMessage: '/addDoubtMessage',
  updateDoubtStatus: '/updateDoubtStatus',

  // Exports
  exportStudentsToExcel: '/exportStudentsToExcel',
  exportAttendanceToExcel: '/exportAttendanceToExcel',
  exportLeadsToExcel: '/exportLeadsToExcel',
  AddProfileImgStdPy: '/save-student-pic-to-db',
  getStudentNotificationsByDate:'/getStudentNotificationsByDate',

  getStudentDocuments: '/getStudentDocuments',
  addStudentDocument: '/addStudentDocument',
  deleteStudentDocument: '/deleteStudentDocument',


  // Notification image upload
  addNotificationImage: '/addNotificationImage',
  addNotificationMedia: '/addNotificationMedia',

  // Progress Report PDF
  generateProgressReport:      '/generateProgressReport',
  generateProgressReportBulk:  '/generateProgressReportBulk',
  generateProgressReportBulkAll: '/generateProgressReportBulkAll',

  // Hall Ticket / Examination
  addExamMaster:            '/addExamMaster',
  getExamMasters:           '/getExamMasters',
  getExamMasterById:        '/getExamMasterById',
  editExamMaster:           '/editExamMaster',
  deleteExamMaster:         '/deleteExamMaster',
  addExamSubject:           '/addExamSubject',
  getExamSubjects:          '/getExamSubjects',
  editExamSubject:          '/editExamSubject',
  deleteExamSubject:        '/deleteExamSubject',
  addHallTicketStudent:     '/addHallTicketStudent',
  getHallTicketStudents:    '/getHallTicketStudents',
  removeHallTicketStudent:  '/removeHallTicketStudent',
  bulkAssignHallTicket:     '/bulkAssignHallTicket',

  getVehiclePathHistory: '/getVehiclePathHistory',

  getCirculars:'/getCirculars',
  addCircular:'/addCircular',
  deleteCircular:'/deleteCircular',
  generateCircular:'/generateCircular',
  getFeesTotalAll:'/getFeesTotalAll',

  // Learning Module
  addLearningModule: '/addLearningModule',
  getLearningModules: '/getLearningModules',
  getLearningModuleDetail: '/getLearningModuleDetail',
  submitLearningModule: '/submitLearningModule',
  getLearningModuleSubmissions: '/getLearningModuleSubmissions',
  deleteLearningModule: '/deleteLearningModule',
  sendLearningModuleNotification: '/sendLearningModuleNotification',
  updateStudyMaterialProgress: '/updateStudyMaterialProgress',
};
